@let loggedInStatus = loggedIn$ | async;

<div class="flex container flex--space-between">
  @if (loggedInStatus === LoginStatus.NOT_LOGGED_IN) {
    <fin-promotion-banner
      class="flex flex--column fill banner-card mr-xsmall-t mr-xsmall-r white-bg surface-primary rounded-large overflow-hidden"
      [class.border]="!isNewBrand()"
      [class.elevation-level-1]="isNewBrand()"
      [imageFromFragment]="'fragments.sustainableTravel'"
      [translationPrefix]="'sustainableTravel'"
      [url]="'sustainableTravel.link.url' | finLocalization"
      [isExternalLink]="true"
    />
  }
  @if (loggedInStatus === LoginStatus.LOGGED_IN) {
    <fin-promotion-banner
      class="flex flex--column fill banner-card mr-xsmall-t mr-xsmall-r white-bg surface-primary rounded-large overflow-hidden"
      [class.border]="!isNewBrand()"
      [class.elevation-level-1]="isNewBrand()"
      [imageFromFragment]="'fragments.donatePoints'"
      [translationPrefix]="'donatePoints'"
      [url]="finnairShopDonateUrl"
      [isExternalLink]="true"
    />
  }
</div>
